import React, { Component } from 'react';
import { translate } from 'react-i18next';

import './IndexContent.css';

class IndexContent extends Component {

  render() {
    const { data } = this.props;
    return (
      <div className='index-content-container'>
        <p className='ic-title'>{data.title}</p>
        <p className='ic-subtitle'>{data.subtitle}</p>
        <div className='ic-content' dangerouslySetInnerHTML={{ __html: data.content }} ></div>
      </div>
    );
  }
}

export default translate()(IndexContent);
